/* deen-home.js — hero carousel + product carousel arrows. Loaded (deferred) by the hz-* sections. */
(function () {
  if (window.__deenHomeLoaded) return;
  window.__deenHomeLoaded = true;

  function initHero(car) {
    if (car.__hzReady) return;
    car.__hzReady = true;
    var slides = car.querySelectorAll('.hz-heroslide');
    var dots = car.querySelectorAll('.hz-herodot');
    var n = slides.length;
    var seconds = parseInt(car.getAttribute('data-autoplay'), 10) || 0;
    var i = 0, timer = null, sx = 0, sy = 0, swiping = false;
    if (n < 2) return;

    function go(k) {
      i = (k + n) % n;
      slides.forEach(function (s, x) { s.classList.toggle('is-active', x === i); });
      dots.forEach(function (d, x) { d.classList.toggle('is-active', x === i); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (seconds > 0) timer = setInterval(function () { go(i + 1); }, seconds * 1000);
    }

    car.addEventListener('click', function (e) {
      var dot = e.target.closest('.hz-herodot');
      if (dot) { go(parseInt(dot.getAttribute('data-i'), 10)); start(); return; }
      if (e.target.closest('.hz-heroarrow--next')) { go(i + 1); start(); return; }
      if (e.target.closest('.hz-heroarrow--prev')) { go(i - 1); start(); return; }
    });
    car.addEventListener('touchstart', function (e) {
      var p = e.changedTouches[0]; sx = p.clientX; sy = p.clientY; swiping = true; stop();
    }, { passive: true });
    car.addEventListener('touchend', function (e) {
      if (!swiping) return;
      swiping = false;
      var p = e.changedTouches[0], dx = p.clientX - sx, dy = p.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? i + 1 : i - 1);
      start();
    }, { passive: true });
    car.addEventListener('mouseenter', stop);
    car.addEventListener('mouseleave', start);
    start();
  }

  function initAll() {
    document.querySelectorAll('[data-hz-hero]').forEach(initHero);
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest('.hz-fc-arrow');
    if (!button) return;
    var row = button.closest('.hz-fc');
    var track = row && row.querySelector('.hz-fc-track');
    if (!track) return;
    var card = track.querySelector('.hz-fc-card');
    var width = card ? card.getBoundingClientRect().width : 320;
    var gap = window.innerWidth <= 749 ? 12 : 20;
    var dir = parseInt(button.getAttribute('data-dir'), 10) || 1;
    track.scrollBy({ left: (width + gap) * dir, behavior: 'smooth' });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
